
import React from 'react';
import { Button } from './Button';

interface PrintModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
  contentClassName?: string; // Will now be like 'label-print-base label-print-3_5x2in'
}

export const PrintModal: React.FC<PrintModalProps> = ({ 
  isOpen, 
  onClose, 
  title, 
  children,
  contentClassName = 'printable-area label-print-base label-print-3_5x2in' // Default to base + large general
}) => {
  if (!isOpen) return null;

  const handlePrint = () => {
    window.print();
  };

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center p-4 z-[200] no-print"
      aria-labelledby="print-modal-title"
      role="dialog"
      aria-modal="true"
      onClick={onClose}
    >
      <div
        className="bg-white p-6 rounded-lg shadow-xl w-full max-w-3xl max-h-[90vh] flex flex-col no-print"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex justify-between items-center mb-4 border-b pb-3">
          <h2 id="print-modal-title" className="text-xl font-semibold text-slate-800">
            {title}
          </h2>
          <button
            onClick={onClose}
            className="text-slate-500 hover:text-slate-700"
            aria-label="Close modal"
          >
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        {/* The contentClassName will now apply specific print dimensions */}
        <div className={`flex-grow overflow-y-auto border rounded-md p-4 bg-white shadow-inner ${contentClassName}`}>
          {children}
        </div>

        <div className="border-t pt-4 mt-4 flex justify-end space-x-3">
          <Button type="button" variant="ghost" onClick={onClose}>
            Close
          </Button>
          <Button type="button" variant="primary" onClick={handlePrint}>
            Print
          </Button>
        </div>
      </div>
    </div>
  );
};
